import { combineReducers } from 'redux';

const reducers = {
  foremanPuppetEnc: combineReducers({}),
};

export default reducers;



// WEBPACK FOOTER //
// ./vendor/ruby/2.7.0/gems/foreman_puppet-5.1.2/webpack/src/reducers.js